import React, { useRef, useEffect } from "react";
import { useMessageStore } from "./message-store-context";
import { Loader, Button, Icon } from "semantic-ui-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const ChatBotMessages = ({ isLoading }) => {
  const { messages } = useMessageStore();
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  useEffect(() => {
    const links = document.querySelectorAll(".chatbot-message-text a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });
  }, [messages]);

  return (
    <div className="chatbot-messages">
      {(messages ?? []).map((msg, index) => (
        <div>
          <div key={index} className={`chatbot-message ${msg.role}`}>
            <div className="chatbot-message-text">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {String(msg.content.trim())}
              </ReactMarkdown>
            </div>
          </div>
          {msg.role === "assistant" && !isLoading && (
            <Button
              icon
              basic
              size="mini"
              className="copy-btn"
              onClick={() => navigator.clipboard.writeText(msg.content)}
              title="Copy"
            >
              <Icon name="copy" />
            </Button>
          )}
        </div>
      ))}
      {isLoading && (
        <div className="chatbot-typing">
          <Loader active inline="centered" size="small" />
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatBotMessages;
